/* eslint-disable spire/export-styles */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

const StyledSpan = getStyledWrapper("span");

export interface PageTitleCustomStyles {
    titleText?: TypographyPresentationProps;
    container?: InjectableCss;
}

export const pageTitleCustomStyles: PageTitleCustomStyles = {
    titleText: {
        variant: "h3",
        css: css`
            font-size:28px;
            font-weight:500;
            color:${getColor("secondary.main")}; 
            width: 100%; 
            line-height: 25px;
            margin: 0px !important;
            display: inline-block;
            position: relative;
            z-index: 8;
            & span { 
            background:#FFFFFF; 
            padding-right:10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 23px;
                    `,
                    css`
                        font-size: 23px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            padding: 20px 0px;
            max-width: 1440px;
            margin: 0 auto;
            &:after {
                content: "";
                height: 2.4px;
                background: #0000fe;
                width: 100%;
                display: inline-block;
                position: relative;
                bottom: 29px;
                z-index: 1;
            }
        `,
    },
};

const styles = pageTitleCustomStyles;

const PageTitleCustom: React.FunctionComponent<Props> = ({ fields }: Props) => (
    <StyledWrapper {...styles.container}>
        <Typography {...styles.titleText}>
            <StyledSpan>{fields.title}</StyledSpan>
        </Typography>
    </StyledWrapper>
);

const widgetModule: WidgetModule = {
    component: PageTitleCustom,
    definition: {
        group: "Basic",
        icon: "PageTitle",
        fieldDefinitions: [
            {
                name: "title",
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
